import React from 'react'
import {BsLinkedin, bsInstagram, BsInstagram} from "react-icons/bs"
import {FaGithub} from "react-icons/fa"


const SocialMedia = () => {
  return (
    <div className="app__social">
        <div>
            <a href="https://www.linkedin.com/in/thomas-schmitz-181b68204/" target="_blank"><BsLinkedin /></a>
        </div>
        <div>
            <a href="https://www.instagram.com/thomasschmitz2005/?hl=pt-br" target="_blank"><BsInstagram /></a>
        </div>
        <div>
            <a href="https://github.com/thschmitz" target="_blank"><FaGithub/></a>
        </div>

    </div>
  )
}

export default SocialMedia